import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ISubheaderLeftSection, ISubheaderMiddleSection, ISubheaderRightSection } from './sub-header.modal';
import { SubheaderHandlerService } from './../../../core/nav/subheader-handler.service';

@Component({
    selector: 'nalco-sub-header',
    templateUrl: './sub-header.component.html',
    standalone: false
})
export class SubHeaderComponent implements OnInit, OnDestroy {
  private subHeaderService = inject(SubheaderHandlerService);
  private cd = inject(ChangeDetectorRef);

  leftSection: ISubheaderLeftSection;
  middleSection: ISubheaderMiddleSection;
  rightSection: ISubheaderRightSection;
  readonly rightTemplate = this.subHeaderService.rightTemplate;
  @Input() isExpand : boolean;
  @Input() isHomePage = false;
  isMobile: boolean;
  private subscriptions: Subscription[] = [];
  headerColor: string = 'white-header-background';

  btnClicked(which) {
    this.subHeaderService.btnClickInSubhead(which);
    this.cd.markForCheck();
  }

  ddChange(data) {
    this.subHeaderService.ddChangeInSubhead(data);
    this.cd.markForCheck();
  }

  ngOnInit() {
    this.isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    this.subscriptions.push(this.subHeaderService.subheaderLeftSection$.subscribe(async (update) => {
      this.leftSection = await update;
      this.cd.markForCheck();
    }));

    this.subscriptions.push(this.subHeaderService.subheaderMiddleSection$.subscribe(async (update) => {
      this.middleSection = await update;
        this.cd.markForCheck();
    }));

    this.subscriptions.push(this.subHeaderService.subheaderRightSection$.subscribe(async (update) => {
      this.rightSection = await update;
      this.cd.markForCheck();
    }));
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
